//Modal components definitons
export const
    COMPANY_PICKER = "COMPANY_PICKER",
    PRODUCT_PICKER = "PRODUCT_PICKER",
    COMPLAINT_POSITION = "COMPLAINT_POSITION",
    UPDATE_WAYBILL_DATA="UPDATE_WAYBILL_DATA",
    FILE_PREVIEW="FILE_PREVIEW",
    PURCHASE_ADDRESS="PURCHASE_ADDRESS",
    RODO_CLAUSE="RODO_CLAUSE";



// WEBPACK FOOTER //
// ./src/const/Modals.js